var render = function render(){var _vm=this,_c=_vm._self._c;return _c('UnitsFrame',[_c('FlashcardHeader',{on:{"click":function($event){return _vm.$router.push({ name: 'UnitsAreasSpecialities' })}}},[_vm._v(" "+_vm._s(_vm.activeSpeciality ? _vm.activeSpeciality.nombre : "Cargando...")+" ")]),_c('AreasSpecialitiesTopics')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }